import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class TimeslotsAreoverlappingError extends ExpectedError {
  static override _class = 'TimeslotsAreoverlappingError';

  public constructor() {
    super('TimeslotsAreoverlappingError', { translationKey: 'OVERLAPPING_TIMESLOTS_ERROR' });
  }
}
